export default __webpack_public_path__ + "static/media/2.3313af5a.png";